import React from "react";
import { GameSoundsContext } from "./GameSoundsContext";

export const useGameSounds = () => {
  return React.useContext(GameSoundsContext);
};

export * from "./GameSoundsProvider";
